import { Xml2JsonParser } from "../../../data/protocols/xml-parser/xml-2-json-parser";
import { Xml2JsonParserImplementation } from "../../../infra/Xml2JsonParser/xml-2-json-parser";

export const makeXmls2JsonParser = (): Xml2JsonParser => {
  return new Xml2JsonParserImplementation();
};
